import React from "react";

/**
 * Texto em células de placa mecânica. Cada célula guarda uma única letra e
 * reserva exatamente a largura dela, então o espaçamento é o mesmo em repouso e
 * em movimento — nenhuma etapa da animação mexe no layout.
 *
 * fase: "parado" | "saindo" | "entrando"
 * tique: contador da onda, avançado por quem usa o componente
 * atraso: quantos tiques esperar antes desta primeira letra
 */
const PlacaTexto = ({ texto, fase = "parado", tique = 0, atraso = 0 }) => {
  let posicao = 0;
  const palavras = texto.split(" ");

  return (
    <>
      {palavras.map((palavra, p) => {
        const celulas = [...palavra].map((letra) => {
          const marca = atraso + posicao;
          posicao += 1;

          const passou = tique >= marca;
          let situacao = "presente";
          if (fase === "entrando") situacao = passou ? "entrou" : "esperando";
          else if (fase === "saindo") situacao = passou ? "saiu" : "presente";

          return (
            <span className="placa-celula" key={marca}>
              <span className="placa-medida">{letra}</span>
              <span className="placa-poco">
                {/* a key troca junto com a situação: é isso que faz a animação
                    de entrada ou de saída rodar uma vez */}
                <span className={`placa-face placa-${situacao}`} key={situacao}>
                  {letra}
                </span>
              </span>
            </span>
          );
        });

        posicao += 1;

        return (
          <React.Fragment key={p}>
            <span className="placa-palavra">{celulas}</span>
            {p < palavras.length - 1 ? " " : null}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default PlacaTexto;
